import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { DialogData } from 'app/core/interfaces/dialog';
import { SearchCepComponent } from 'app/modules/shared/components/map/search-cep/search-cep.component';
import { MaterialDialog } from 'app/modules/shared/components/dialog/dialog.component';
import { ProcedureRegistrationComponent } from 'app/modules/organization/pages/procedure/registration/procedure-registration.component';
import { PractionerSecretaryLinkComponent } from 'app/modules/secretaries/pages/practioner/bond/practioner-registration.component';
import { ScheduleSecretaryEditStatusComponent } from 'app/modules/secretaries/pages/schedule/status/edit-status/schedule-edit-status.component';
import { ScheduleSecretaryDetailsComponent } from 'app/modules/secretaries/pages/schedule/status/details/schedule-details.component';
import { PaymentDetailsComponent } from 'app/pages/payment/payment-details/payment-details.component';
import { Observable } from 'rxjs';
import { PractitionerRegistrationComponent } from 'app/modules/practitioner/components/practitioner-registration/practitioner-registration.component';
import { NovaSenhaComponent } from 'app/pages/recuperar-senha/nova-senha/nova-senha.component';

@Injectable({
  providedIn: 'root',
})
export class DialogService {
  constructor(public dialog: MatDialog) {}

  openDialog(data: DialogData) {
    const dialogRef = this.dialog.open(MaterialDialog, {
      data: {
        title: data.title ? data.title : 'Aviso',
        content: data.content ? data.content : 'Você realmente deseja fazer essa ação?',
        buttonText: data.buttonText ? data.buttonText : 'Ok',
        showButtonCancel: data.showButtonCancel ? data.showButtonCancel : true,
        component: data.component ? data.component : null,
      },
      minHeight: '200px',
    });

    return dialogRef.afterClosed();
  }

  openComponentDialog(component: any, data: any, config: MatDialogConfig = { width: '1400px', maxWidth: '92%', minHeight: '80vh' }): Observable<any> {
    const dialogRef = this.dialog.open(component, {
      data,
      ...config,
    });

    return dialogRef.afterClosed();
  }

  openMediumComponentDialog(
    component: any,
    data: any,
    config: MatDialogConfig = { width: '800px', maxWidth: '92%', minHeight: '70vh' },
  ): Observable<any> {
    const dialogRef = this.dialog.open(component, {
      data,
      ...config,
    });

    return dialogRef.afterClosed();
  }

  openMediumComponentDialogRef(
    component: any,
    data: any,
    config: MatDialogConfig = { width: '800px', maxWidth: '92%', minHeight: '70vh' },
  ): MatDialogRef<any> {
    return this.dialog.open(component, { data, ...config });
  }

  openSmallComponentDialog(
    component: any,
    data: any,
    config: MatDialogConfig = { width: '500px', maxWidth: '92%', minHeight: '50vh' },
  ): Observable<any> {
    const dialogRef = this.dialog.open(component, {
      data,
      ...config,
    });

    return dialogRef.afterClosed();
  }

  openScheduleSecretaryStatusDialog(data: any) {
    const dialogRef = this.dialog.open(ScheduleSecretaryEditStatusComponent, {
      data,
    });
    return dialogRef.afterClosed();
  }

  openScheduleSecretaryDetailDialog(data: any) {
    const dialogRef = this.dialog.open(ScheduleSecretaryDetailsComponent, {
      data,
      width: '1024px',
      maxWidth: '92%',
      minHeight: '70vh',
    });
    return dialogRef.afterClosed();
  }

  openPractitionerSecretaryLinkDialog(data: any) {
    const dialogRef = this.dialog.open(PractionerSecretaryLinkComponent, {
      data,
      width: '1024px',
      maxWidth: '92%',
      minHeight: '70vh',
    });
    return dialogRef.afterClosed();
  }

  openProcedureFormDialog(data: any) {
    const dialogRef = this.dialog.open(ProcedureRegistrationComponent, {
      data,
      width: '1400px',
      maxWidth: '92%',
      minHeight: '70vh',
    });
    return dialogRef.afterClosed();
  }

  openRegisterFormDialog(data: any) {
    const dialogRef = this.dialog.open(PractitionerRegistrationComponent, {
      data,
      width: '1400px',
      maxWidth: '92%',
      minHeight: '70vh',
    });
    return dialogRef.afterClosed();
  }

  openPrescriptionFormDialog(data: any) {
    /**  
    const dialogRef = this.dialog.open(PrescriptionRegistrationComponent, {
      data, width: '1400px', maxWidth: '90%', minHeight: '70vh',
    });
    return dialogRef.afterClosed();*/
  }

  openSearchCepDialog(data: DialogData) {
    const dialogRef = this.dialog.open(SearchCepComponent, {
      data,
      width: '400px',
      maxWidth: '92%',
      minHeight: '200px',
    });
    return dialogRef.afterClosed();
  }

  openNovaSenhaDialog(data: DialogData) {
    const dialogRef = this.dialog.open(NovaSenhaComponent, {
      data,
      width: '500px',
      maxWidth: '92%',
      minHeight: '200px',
    });
    return dialogRef.afterClosed();
  }

  openPaymentMethodDetailDialog(data: any) {
    const dialogRef = this.dialog.open(PaymentDetailsComponent, {
      data,
      width: '1024px',
      maxWidth: '90%',
      minHeight: '70vh',
    });
    return dialogRef.afterClosed();
  }

  openSecretaryDetailDialog(data: any) {}
}
